import type {GlyphRun, Palette} from '@github-ui/taillights-worker/document'
import {taillightsColorVariable} from './taillights-rendering-styles'

/** Renders prepared glyph runs, preserving native emoji colors and Safari's generated-text paint path. */
export function TaillightsGlyphs({
  text,
  runs,
  pseudoText,
  palette,
}: {
  text: string
  runs: readonly GlyphRun[]
  pseudoText: boolean
  palette?: Palette
}) {
  return (
    <>
      {runs.map(run => {
        const value = text.slice(run.start, run.end)
        if (!pseudoText && !run.bold && !run.italic && !run.underline && !run.nativeText) return value
        const colorVariable = run.nativeText && run.colorKey ? taillightsColorVariable(run.colorKey) : undefined
        return (
          <span
            key={run.start}
            data-taillights-pseudo-text={pseudoText || undefined}
            data-taillights-text={pseudoText ? value : undefined}
            data-taillights-native-text={run.nativeText || undefined}
            style={{
              color: palette
                ? (run.colorKey && Object.hasOwn(palette.colors, run.colorKey) && palette.colors[run.colorKey]) ||
                  palette.defaultColor
                : undefined,
              '--taillights-native-color': colorVariable
                ? `var(${colorVariable}, var(--taillights-default-color))`
                : undefined,
              fontWeight: run.bold ? 'bold' : undefined,
              fontStyle: run.italic ? 'italic' : undefined,
              textDecoration: run.underline ? 'underline' : undefined,
            }}
          >
            {pseudoText ? null : value}
          </span>
        )
      })}
    </>
  )
}
